<template>
  <transition name="router-fade" mode="out-in">
    <div onbeforeunload="ZMtj" id="app" class="app">
      <header-v1></header-v1>
      <router-view></router-view>
    </div>
  </transition>
</template>

<script>
import headerV1 from "@/components/common/headerV1";
import api from "@/api";
import {queryObj} from '@/utils/util'
export default {
  name: "app",
  data() {
    return {
      beginTime: new Date().getTime(),
      endTime: "",
      hasType: ""
    };
  },
  created() {
    console.log("----------------------------------")
    this.$store.dispatch("getSubjectData");
    //this.ZMtj();
    //window.onbeforeunload = () => { this.ZMtj() }
    var pathName = this.$route.name;
    if (
      pathName == "appointment-success" ||
      pathName == "appointment-success2" ||
      pathName == "appointment-success3" ||
      pathName == "appointment-success4" ||
      pathName == "appointment-success5"
    ) {
      this.hasType = "type:预约成功页";
    } else {
      this.hasType = "type:推广落地页";
    }
    this.ZMtj();
  },
  beforeDestory() {
  },
  components: {
    headerV1
  },
  methods: {
    ZMtj() {
      //var time = new Date().getTime() - this.beginTime
      var params =
        [
          {
            page_id: this.$route.path,
            page_name: "",
            refer_page_id: "",
            refer_page_name: "",
            device_id: this.getCookie("_ga"),
            user_id: "",
            tracker_type: "3",
            channel_id: this.$route.query.channel_code,
            session_id: "",
            time_start: this.beginTime,
            duration: "",
            content: "",
            linkurl: "",
            expand: this.hasType,
            app_id: "",
            platform: "m"
          }
        ]
        if(!params || params == "{}"){
          return
        }
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  },
  watch: {
    $route (to, from) {

    }
  },
  mounted(){

  }
  // beforeRouteEnter(to, from, next) {
  //   console.log("跳转了");
  //   next();
  // }
};
</script>

<style lang="scss">
@import "styles/common.scss";

#app {
  position: relative;
  width: px2rem(750);
  margin: 0 auto;
}
/*  .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .3s;
  }
  .router-fade-enter, .router-fade-leave-active {
    opacity: 0;
  }*/
</style>
